export default {
    HOME: {
        ROUTE: '/',
    },
    BOXES: {
        ROUTE: '/boxes',
    },
}